import React from 'react';
import CourseList from './CourseList';

const LeftSidebar = ({
  courses,
  onAddCourse,
  onRemoveCourse,
  onShowCourseDetails,
  onShowBatchModal
}) => {
  return (
    <div className="w-64 flex-shrink-0 flex flex-col gap-5 h-fit">
      <CourseList
        courses={courses}
        onAddCourse={onAddCourse}
        onRemoveCourse={onRemoveCourse}
        onShowCourseDetails={onShowCourseDetails}
        onShowBatchModal={onShowBatchModal}
      />
    </div>
  );
};

export default LeftSidebar;
